import {Component, OnDestroy, OnInit} from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatButtonModule } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { MatListModule } from '@angular/material/list'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { MatCardModule } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { AuthService } from '../../../core/services/auth/auth.service'
import {FormClientSearchComponent} from '../../../shared/components/form-client-search/form-search.component';
import {NgForOf, NgIf, NgOptimizedImage, NgStyle} from '@angular/common';
import {
  MonitoringService
} from '../../../core/services/monitoring/legal-entity-client/monitoring.service';
import {PatientComponent} from '../../patient/patient/patient.component';
import {MonitoringDetailsComponent} from '../../../features/monitoring/monitoring/monitoring-details.component';
@Component({
  selector: 'monitoring',
  standalone: true,
  imports: [
    MatButtonModule,
    MatCardModule,
    MatListModule,
    MatPaginatorModule,
    MatProgressBarModule,
    FormClientSearchComponent,
    NgIf,
    NgForOf,
    NgStyle,
    NgOptimizedImage,
  ],
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss'],
})
export class MonitoringComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private serviceGustavo: MonitoringService,
  ) {
  }

  gustavoInterval: any
  page: number = 1
  rows: number = 10
  numberRows: number = 0
  pacientes: any[] = []
  loading: boolean = false

  inputSearch: any = {type: '', search: ''}
  searchForm: any = {search: false, model: {}}

  listSearch: any = [
    {
      id: 'nome_paciente',
      description: 'Nome',
      type: 'string',
      visible: true,
    },
    {
      id: 'nivel_urgencia',
      description: 'Urgência',
      type: 'string',
      visible: true,
    },
  ]
  startIntervalGustavo() {
    this.gustavoInterval = setInterval(() => {
      this.serviceGustavo.webhookGustavo().subscribe({
        next: (response: any) => {
          console.log(response, 'resposta');
        },
        error: () => {},
        complete: () => {},
      });
    }, 10000);
  }

  ngOnDestroy() {
    if (this.gustavoInterval) {
      clearInterval(this.gustavoInterval);
    }
  }
  getBorderGradient(exames: any[]): string {
    if (!exames || exames.length === 0) return '';

    const step = 100 / exames.length;
    let gradientParts: string[] = [];

    exames.forEach((exame, index) => {
      const start = step * index;
      const end = step * (index + 1);
      if(exames.length > 1){
      gradientParts.push(`${exame.hexadecimal} ${start}% ${end-2}%, #000000 ${end}% ${end+2}%`);
      }
      else{
    gradientParts.push(`${exame.hexadecimal} ${start}% ${end}%`);
      }
    });

    return `conic-gradient(${gradientParts.join(', ')})`;
  }
  ngOnInit() {
    this.getListItems()
    this.startIntervalGustavo()
    this.pacientes = [
      {
        "id_paciente": 1,
        "nome_paciente": "Ana Clara",
      exame: [{
          "exame": "glicemia",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#FFA500",
        "valor_glicose": 180,
        "tipo_unidade": "mmol/L",
        "limite_min": 70,
        "limite_max": 140,
      },
        {
          "exame": "pressão",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#03a903",
        "valor_glicose": 180,
        "tipo_unidade": "mmol/L",
        "limite_min": 70,
        "limite_max": 140,
      },{
          "exame": "glicemia",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#d50303",
        "valor_pressao": "12/8",
        "tipo_unidade": "",
        "limite_min": 13/9,
        "limite_max": 11/7,
      }],
        "unidade_saude": "Posto Central"
      },
      {
        "id_paciente": 2,
        "nome_paciente": "Bruno Silva",
        exame: [{
          "nivel_urgencia": "Urgente",
          "hexadecimal": "#d50303",
          "valor_glicose": 180,
          "tipo_unidade": "mmol/L",
          "limite_min": 70,
          "limite_max": 140,
        }],
        "unidade_saude": "UBS Jardim"
      },
      {
        "id_paciente": 3,
        "nome_paciente": "Carla Souza",
        "nivel_urgencia": "Alerta",
        "tipo_unidade": "mmol/L",
        "hexadecimal": "#FFA500",
        "valor_glicose": 150,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "Hospital Municipal"
      },
      {
        "id_paciente": 4,
        "nome_paciente": "Diego Ferreira",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#d50303",
        "tipo_unidade": "mmol/L",
        "valor_glicose": 110,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "Posto Bairro Novo"
      },
      {
        "id_paciente": 5,
        "nome_paciente": "Eduarda Lima",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#d50303",
        "valor_glicose": 200,
        "limite_min": 70,
        "limite_max": 140,
        "tipo_unidade": "mg/dL",
        "unidade_saude": "Clínica Popular"
      },
      {
        "id_paciente": 6,
        "nome_paciente": "Felipe Andrade",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#FFA500",
        "valor_glicose": 85,
        "tipo_unidade": "mg/dL",
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "UBS Primavera"
      },
      {
        "id_paciente": 1,
        "nome_paciente": "Ana Clara",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#d50303",
        "valor_glicose": 180,
        "limite_min": 70,
        "limite_max": 140,
        "tipo_unidade": "mg/dL",
        "unidade_saude": "Posto Central"
      },
      {
        "id_paciente": 2,
        "nome_paciente": "Bruno Silva",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#03a903",
        "valor_glicose": 95,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "UBS Jardim"
      },
      {
        "id_paciente": 3,
        "nome_paciente": "Carla Souza",
        "nivel_urgencia": "Alerta",
        "hexadecimal": "#FFA500",
        "valor_glicose": 150,
        "limite_min": 70,
        "tipo_unidade": "mg/dL",
        "limite_max": 140,
        "unidade_saude": "Hospital Municipal"
      },
      {
        "id_paciente": 4,
        "nome_paciente": "Diego Ferreira",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#FFA500",
        "valor_glicose": 110,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "Posto Bairro Novo",
        "tipo_unidade": "mmol/L",
      },
      {
        "id_paciente": 5,
        "nome_paciente": "Eduarda Lima",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#FFA500",
        "valor_glicose": 200,
        "limite_min": 70,
        "tipo_unidade": "mmol/L",
        "limite_max": 140,
        "unidade_saude": "Clínica Popular"
      },
      {
        "id_paciente": 6,
        "nome_paciente": "Felipe Andrade",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#d50303",
        "valor_glicose": 85,
        "tipo_unidade": "mmol/L",
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "UBS Primavera"
      },
      {
        "id_paciente": 1,
        "nome_paciente": "Ana Clara",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#d50303",
        "valor_glicose": 180,
        "tipo_unidade": "mmol/L",
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "Posto Central"
      },
      {
        "id_paciente": 2,
        "nome_paciente": "Bruno Silva",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#03a903",
        "tipo_unidade": "mmol/L",
        "valor_glicose": 95,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "UBS Jardim"
      },
      {
        "id_paciente": 3,
        "nome_paciente": "Carla Souza",
        "nivel_urgencia": "Alerta",
        "tipo_unidade": "mmol/L",
        "hexadecimal": "#FFA500",
        "valor_glicose": 150,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "Hospital Municipal"
      },
      {
        "id_paciente": 4,
        "nome_paciente": "Diego Ferreira",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#d50303",
        "tipo_unidade": "mmol/L",
        "valor_glicose": 110,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "Posto Bairro Novo"
      },
      {
        "id_paciente": 5,
        "nome_paciente": "Eduarda Lima",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#FFA500",
        "valor_glicose": 200,
        "limite_min": 70,
        "limite_max": 140,
        "tipo_unidade": "mg/dL",
        "unidade_saude": "Clínica Popular"
      },
      {
        "id_paciente": 6,
        "nome_paciente": "Felipe Andrade",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#FFA500",
        "valor_glicose": 85,
        "tipo_unidade": "mg/dL",
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "UBS Primavera"
      },
      {
        "id_paciente": 1,
        "nome_paciente": "Ana Clara",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#d50303",
        "valor_glicose": 180,
        "limite_min": 70,
        "limite_max": 140,
        "tipo_unidade": "mg/dL",
        "unidade_saude": "Posto Central"
      },
      {
        "id_paciente": 2,
        "nome_paciente": "Bruno Silva",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#03a903",
        "valor_glicose": 95,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "UBS Jardim"
      },
      {
        "id_paciente": 3,
        "nome_paciente": "Carla Souza",
        "nivel_urgencia": "Alerta",
        "hexadecimal": "#FFA500",
        "valor_glicose": 150,
        "limite_min": 70,
        "tipo_unidade": "mg/dL",
        "limite_max": 140,
        "unidade_saude": "Hospital Municipal"
      },
      {
        "id_paciente": 4,
        "nome_paciente": "Diego Ferreira",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#03a903",
        "valor_glicose": 110,
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "Posto Bairro Novo",
        "tipo_unidade": "mmol/L",
      },
      {
        "id_paciente": 5,
        "nome_paciente": "Eduarda Lima",
        "nivel_urgencia": "Urgente",
        "hexadecimal": "#03a903",
        "valor_glicose": 200,
        "limite_min": 70,
        "tipo_unidade": "mmol/L",
        "limite_max": 140,
        "unidade_saude": "Clínica Popular"
      },
      {
        "id_paciente": 6,
        "nome_paciente": "Felipe Andrade",
        "nivel_urgencia": "Normal",
        "hexadecimal": "#03a903",
        "valor_glicose": 85,
        "tipo_unidade": "mmol/L",
        "limite_min": 70,
        "limite_max": 140,
        "unidade_saude": "UBS Primavera"
      }
    ];
  }


  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {}
    for (let item of this.listSearch) {
      model[item.id] = item.id === element.type ? element.search : ''
    }
    return model
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type: 'new' | '' = '') {
    if (type === 'new') {
      this.searchForm = {search: false, model: {}}
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  getListItems() {
    // this.patientService.listPagedPatient(this.page, this.rows).subscribe({
    //   next: (response: any) => {
    //     this.treatResponse(response)
    //   },
    //   error: () => {},
    //   complete: () => {
    //     this.loading = false
    //   },
    // })

  }

  searchListItems() {
    this.loading = true
    // this.patientService
    //   .searchPagedPatient(this.page, this.rows, this.searchForm.model)
    //   .subscribe({
    //     next: (response: any) => {
    //       this.treatResponse(response)
    //     },
    //     error: () => {},
    //     complete: () => {
    //       this.loading = false
    //     },
    //   })
  }

  newPatient() {
    // const dialogRef = this.dialog.open(PatientCreateComponent, {
    //   maxWidth: '100vw',
    //   width: '100vw',
    //   maxHeight: '100vh',
    //   height: '100vh',
    //   panelClass: 'dialog-fullscreen',
    // })
    // dialogRef.componentInstance.responseCreate.subscribe(() => {
    //   this.uploadList()
    // })
    console.log('add')

  }

  viewItem(item: any) {
      const dialogRef = this.dialog.open(MonitoringDetailsComponent, {
        maxWidth: '97vw',
        width: '97vw',
        maxHeight: '97vh',
        height: '97vh',
        panelClass: 'dialog-screen',
        data: { item },
      })
      // dialogRef.componentInstance.responseEdit.subscribe(() => {
      //   this.uploadList()
      // })
    console.log('edit')
    }
  }
